import axios from "axios";
import config from "../config";


export const getAwardService = (awardId: string) => axios.get(`${config.API_URL}/awards/${awardId}`)
export const getAllAwardsService = () => axios.get(`${config.API_URL}/awards`)

export const createAwardService = ({ name, code, description, token }: { name: string, code: string, description: string, token: string }) => axios.post(`${config.API_URL}/awards`, {
    name, code, description
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const updateAwardService = ({ name, code, description, token, awardId }: { name: string, code: string, description: string, token: string, awardId: string }) => axios.patch(`${config.API_URL}/awards/${awardId}`, {
    name, code, description
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})